import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTrendingUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 7,
	viewBox: "0 0 12 7",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.816667 7L0 6.18333L4.31667 1.8375L6.65 4.17083L9.68333 1.16667H8.16667V0L11.6667 0V3.5H10.5V1.98333L6.65 5.83333L4.31667 3.5L0.816667 7Z",
		fill: "#34A853"
	})
});
export default SvgTrendingUp;
